/**
 * "/" — public marketing landing.
 *
 * Logged-out (first-time) visitors see the landing page; every "File Your ITR"
 * CTA routes to /login. Anyone with a session skips straight to the dashboard.
 *
 * Auth check mirrors _protected.tsx: the refresh token in the token store is
 * the synchronous source of truth (router context can lag by a tick right
 * after login), and a genuinely-stale session is still logged out later by the
 * api-client's 401 handler.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';
import { tokenStore } from '@/lib/api';
import { LandingPage } from '@/features/landing/landing-page';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (tokenStore.getRefreshToken()) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: LandingPage,
});
